<template lang="pug">
.main-content
  //- .form-group
  //-   label.col-md-12 本体型式
  //-   .col-md-12
  //-     el-input(type='text',value='', v-model='swanData.model')
  .form-group
    label.col-md-12 本体総重量
    .col-md-12
      el-input(type='text',value='', v-model='swanData.weight')
  .form-group
    label.col-md-12 電気容量
    .col-md-12
      el-input(type='text',value='', v-model='swanData.powerSupply')
  .form-group
    label.col-md-12 圧縮エアー
    .col-md-12
      el-input(type='text',value='', v-model='swanData.air')
  .form-group
    label.col-md-12 可搬重量
    .col-md-12
      el-input(type='text',value='', v-model='swanData.vWeight')
  .form-group
    label.col-md-12 最大ガン搭載数
    .col-md-12
      el-input(type='text',value='', v-model='swanData.maxGun')
  .form-group
    label.col-md-12 動作速度
    .col-md-12
      el-input(type='text',value='', v-model='swanData.speed')
  .form-group
    label.col-md-12 位置繰り返し精度
    .col-md-12
      el-input(type='text',value='', v-model='swanData.accuracy')
  .form-group
    label.col-md-12 アーム長
    .col-md-12
      el-input(type='text',value='', v-model='swanData.arm')
  .form-group
    label.col-md-12 モータ容量
    .col-md-12
      .col-md-12
      label.col-md-12 第1軸
      .col-md-12
        el-input(type='text',value='', v-model='swanData.moters[0]')
      label.col-md-12.mt-3 第2軸
      .col-md-12
        el-input(type='text',value='', v-model='swanData.moters[1]')
      label.col-md-12.mt-3 第3軸
      .col-md-12
        el-input(type='text',value='', v-model='swanData.moters[2]')
      label.col-md-12.mt-3 第4軸
      .col-md-12
        el-input(type='text',value='', v-model='swanData.moters[3]')
  .form-group
    label.col-md-12 Wターン 搬送装置 仕様
    .col-md-12
      .col-md-12
      label.col-md-12.mt-3 可搬重量
      .col-md-12
        label.col-md-12 4トップ
        .col-md-12
          el-input(type='text', value='', v-model='swanData.child.payload[0]')
        label.col-md-12.mt-3 1トップ
        .col-md-12
          el-input(type='text', value='', v-model='swanData.child.payload[1]')
      label.col-md-12.mt-3 テーブル間距離
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.tableDistance', @blur='saveData()')
      label.col-md-12.mt-3 W ターンピッチ
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.pitch')
      label.col-md-12.mt-3 Wターン回転速度
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.rSpeed')
      label.col-md-12.mt-3 テーブル回転速度
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.tableSpeed')
      label.col-md-12.mt-3 最大ワーク寸法:直径
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.maxWork.width')
      label.col-md-12.mt-3 最大ワーク寸法:高さ
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.maxWork.height')
      label.col-md-12.mt-3 モータ容量:W ターン
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.motorCapacity.wturn')
      label.col-md-12.mt-3 モータ容量:テーブル
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.motorCapacity.table')
      label.col-md-12.mt-3 位置繰り返し精度
      .col-md-12
        el-input(type='text',value='', v-model='swanData.child.accuracy')
      .form-group.mt-3
        span.col-md-12 1600-4T画像:正面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1600Front")'
        )
        .col-md-12
          el-table(:data='swanData.frontImage1600')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage1600")') 
          input#btn1600Front.hidden(type='file', @change='onFileAdd($event, "frontImage1600")', accept='image/*')
      .form-group
        span.col-md-12 1600-4T画像:側面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1600Side")'
        )
        .col-md-12
          el-table(:data='swanData.sideImage1600')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage1600")') 
          input#btn1600Side.hidden(type='file', @change='onFileAdd($event, "sideImage1600")', accept='image/*')
      .form-group
        span.col-md-12 1600-4T画像:上面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1600Top")'
        )
        .col-md-12
          el-table(:data='swanData.topImage1600')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage1600")') 
          input#btn1600Top.hidden(type='file', @change='onFileAdd($event, "topImage1600")', accept='image/*')

      .form-group.mt-3
        span.col-md-12 1200-4T画像:正面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1200Front")'
        )
        .col-md-12
          el-table(:data='swanData.frontImage1200')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage1200")') 
          input#btn1200Front.hidden(type='file', @change='onFileAdd($event, "frontImage1200")', accept='image/*')
      .form-group
        span.col-md-12 1200-4T画像:側面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1200Side")'
        )
        .col-md-12
          el-table(:data='swanData.sideImage1200')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage1200")') 
          input#btn1200Side.hidden(type='file', @change='onFileAdd($event, "sideImage1200")', accept='image/*')
      .form-group
        span.col-md-12 1200-4T画像:上面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1200Top")'
        )
        .col-md-12
          el-table(:data='swanData.topImage1200')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage1200")') 
          input#btn1200Top.hidden(type='file', @change='onFileAdd($event, "topImage1200")', accept='image/*')
      .form-group.mt-3
        span.col-md-12 1400-2T画像:正面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1400Front")'
        )
        .col-md-12
          el-table(:data='swanData.frontImage1400')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImage1400")') 
          input#btn1400Front.hidden(type='file', @change='onFileAdd($event, "frontImage1400")', accept='image/*')
      .form-group
        span.col-md-12 1400-2T画像:側面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1400Side")'
        )
        .col-md-12
          el-table(:data='swanData.sideImage1400')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImage1400")') 
          input#btn1400Side.hidden(type='file', @change='onFileAdd($event, "sideImage1400")', accept='image/*')
      .form-group
        span.col-md-12 1400-2T画像:上面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btn1400Top")'
        )
        .col-md-12
          el-table(:data='swanData.topImage1400')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImage1400")') 
          input#btn1400Top.hidden(type='file', @change='onFileAdd($event, "topImage1400")', accept='image/*')
      .form-group.mt-3
        span.col-md-12 S画像:正面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btnSFront")'
        )
        .col-md-12
          el-table(:data='swanData.frontImageS')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "frontImageS")') 
          input#btnSFront.hidden(type='file', @change='onFileAdd($event, "frontImageS")', accept='image/*')
      .form-group
        span.col-md-12 S画像:側面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btnSSide")'
        )
        .col-md-12
          el-table(:data='swanData.sideImageS')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "sideImageS")') 
          input#btnSSide.hidden(type='file', @change='onFileAdd($event, "sideImageS")', accept='image/*')
      .form-group
        span.col-md-12 S画像:上面図
        el-button(
          type='primary',
          icon='el-icon-plus',
          size='mini',
          @click='onBtnFileAdd("btnSTop")'
        )
        .col-md-12
          el-table(:data='swanData.topImageS')
            el-table-column(label='image', width='300')
              template(slot-scope='scope')
                img(:src='scope.row.image', height='128')
            el-table-column(property='name', label='name', width='200')
            el-table-column(label='', width='150')
              template(slot-scope='scope')
                el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImage(scope.$index, "topImageS")') 
          input#btnSTop.hidden(type='file', @change='onFileAdd($event, "topImageS")', accept='image/*')
</template>

<script>
export default {
  name: 'Swan',
  data () {
    return {
    }
  },
  props: {
    swanData: Object
  },
  created () {
    if (!this.swanData.child) {
      this.swanData.child = {}
      this.swanData.child.payload = []
      this.swanData.child.maxWork = {}
      this.swanData.child.motorCapacity = {}
    }
    if (!this.swanData.frontImage1600) {
      this.swanData.frontImage1600 = []
    }
    if (!this.swanData.sideImage1600) {
      this.swanData.sideImage1600 = []
    }
    if (!this.swanData.topImage1600) {
      this.swanData.topImage1600 = []
    }
    if (!this.swanData.frontImage1200) {
      this.swanData.frontImage1200 = []
    }
    if (!this.swanData.sideImage1200) {
      this.swanData.sideImage1200 = []
    }
    if (!this.swanData.topImage1200) {
      this.swanData.topImage1200 = []
    }
    if (!this.swanData.frontImage1400) {
      this.swanData.frontImage1400 = []
    }
    if (!this.swanData.sideImage1400) {
      this.swanData.sideImage1400 = []
    }
    if (!this.swanData.topImage1400) {
      this.swanData.topImage1400 = []
    }
    if (!this.swanData.frontImageS) {
      this.swanData.frontImageS = []
    }
    if (!this.swanData.sideImageS) {
      this.swanData.sideImageS = []
    }
    if (!this.swanData.topImageS) {
      this.swanData.topImageS = []
    }
  },
  methods: {
    deleteImage (index, imageType) {
      let imageObject = this.swanData[imageType]
      this.$confirm('画像を削除しますか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        imageObject.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (idName) {
      document.getElementById(idName).click()
    },
    onFileAdd (event, objName) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.swanData[objName].splice(0, 1)
          this.swanData[objName].push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    }
  }
}
</script>

<style lang="scss", scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}
</style>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/Swan.vue